import { Navigate, Route, Routes } from 'react-router-dom'
import ContactRoutes from './ContactRoutes'
import { ProfileLayout } from '../../layout/ProfileLayout'
import CampagnesPage from '../../pages/profile-detail/CampagnePage'
import AutomationPage from '../../pages/profile-detail/AutomationPage'
import AutomationsPage from '../../pages/profile-detail/AutomationsPage'
import ActivitiesPage from '../../pages/profile-detail/ActivitiesPage'
import SettingsPage from '../../pages/profile-detail/SettingsPage'

const ProfileRoutes = () => {
  return (
    <Routes>
      <Route path=":profileSlug/*" element={<ProfileLayout />}>
        <Route path="contacts/*" element={<ContactRoutes />} />
        <Route path="activities" element={<ActivitiesPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="campagnes" element={<CampagnesPage />} />
        <Route path="automations" element={<AutomationsPage />} />
        <Route path="automations/:automationId" element={<AutomationPage />} />
        <Route index path="*" element={<Navigate to={'automations'} />} />
      </Route>
    </Routes>
  )
}

export default ProfileRoutes
